// src/features/messages/components/Composer/FilesGrid.jsx
import { Box, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { getFilePreviewIcon } from "../helpers/extensionFile";
import { useContactCenterTheme } from "../../virtual-receptionist/theming/ContactCenterThemeContext";

export const FilesGrid = ({
  selectedFiles = [],
  selectedImages = [],
  onRemoveFile,
  onRemoveImage,
}) => {
  const { theme } = useContactCenterTheme();
  const hasFiles = selectedFiles.length > 0 || selectedImages.length > 0;

  return (
    <Box
      sx={{
        overflowX: "auto",
        whiteSpace: "nowrap",
        width: "100%",
        py: hasFiles ? 1 : 0,
        px: 2,
      }}
    >
      <Box
        sx={{
          display: "inline-flex",
          gap: 2,
        }}
      >
        {selectedFiles.map((file, index) => (
          <Box
            key={`file-${index}`}
            sx={{
              position: "relative",
              width: 90,
              flex: "0 0 auto",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box
              component="img"
              src={getFilePreviewIcon(file.name)} 
              alt="file icon"
              sx={{
                width: 90,
                height: 100,
                objectFit: "contain",
                borderRadius: 1,
                boxShadow: 1,
                backgroundColor: "background.paper",
                padding: 1,
              }}
            />
            <Typography
              variant="caption"
              noWrap
              sx={{
                maxWidth: "100%",
                textAlign: "center",
                mt: 1,
              }}
            >
              {file.name}
            </Typography>

            <IconButton
              size="small"
              onClick={() => onRemoveFile?.(file)}
              sx={{
                position: "absolute",
                top: 0,
                right: 0,
                backgroundColor: theme.shell.headerBg,
                color: "error.main",
                borderRadius: "50%",
                p: "2px",
                transform: "translate(40%, -30%)",
                "&:hover": {
                  backgroundColor: "error.light",
                  color: "white",
                },
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        ))}


        {selectedImages.map((image, index) => (
          <Box
            key={`img-${index}`}
            sx={{
              position: "relative",
              width: 90,
              flex: "0 0 auto",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box
              component="img"
              src={URL.createObjectURL(image)} 
              alt="preview"
              sx={{
                width: 90,
                height: 100,
                objectFit: "cover",
                borderRadius: 1,
                boxShadow: 1,
              }}
            />
            <Typography
              variant="caption"
              noWrap
              sx={{ maxWidth: "100%", textAlign: "center" }}
            >
              {image.name}
            </Typography>

         
            <IconButton
              size="small"
              onClick={() => onRemoveImage?.(image)}
              sx={{
                position: "absolute",
                top: 0,
                right: 0,
                backgroundColor: theme.shell.headerBg,
                color: "error.main",
                borderRadius: "50%",
                p: "2px",
                transform: "translate(40%, -30%)",
                "&:hover": {
                  backgroundColor: "error.light",
                  color: "white",
                },
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
